<template>
  <div class="body">
    <div v-for="(p, pindex) in products" :key="pindex" class="product">
      <div class="block">
        <img class="image" :src="p.picture" alt="商品"/>
        <div class="info">
          <div class="title">{{ p.name }}</div>
          <div class="desc">{{ p.pdt_desc }}</div>
          <div class="spec">
            <div class="item case">
              <span>{{ p.count }}</span
              ><span>箱</span>
            </div>
            <div class="item box">
              <span>{{ p.boxnum }}</span
              ><span>盒</span>
            </div>
          </div>
        </div>
      </div>
      <div
          v-for="(s, i) in p.shops"
          :key="i"
          @click="activeThisShop(pindex, i)"
          :class="s.active ? 'store active' : 'store'"
      >
        <div class="cert-id">授权书ID：{{ s.code }}</div>
        <div class="name">
          {{ s.is_company === 0 ? s.auth_shopname : s.auth_company }}
        </div>
        <div class="url">{{ s.shopweb }}</div>
        <img
            v-if="s.active"
            class="checked"
            src="../assets/images/store_checked.png"
            alt="选中"
        />
        <img
            v-if="!s.active"
            class="unchecked"
            src="../assets/images/store.png"
            alt="未选中"
        />
      </div>
    </div>
    <button :class="activeCount > 0 ? 'active-btn fixed' : 'inactive-btn fixed'" @click="doActivate">激活防伪红包</button>
  </div>
</template>

<script>
import Vue from "vue";
import {postApi, showToast, isLogin} from "@/common";

export default {
  name: "Activate",
  data() {
    return {
      products: [],
      shops: [],
      box_code: "",
      member_id: "",
      activeCount: 0
    };
  },
  created() {
    const that = this
    //参数填充
    console.log("路由参数：", this.$route.query);
    this.box_code = this.$route.query.box_code;
    //判断用户是否登录，或者登录之后是否已经过期
    isLogin(that, that.box_code, function () {
      let memberInfo = localStorage.getItem("box_code_member_info");
      memberInfo = JSON.parse(memberInfo);
      that.member_id = memberInfo.member_id;
      that.products = JSON.parse(localStorage.getItem("box_code_product_list"));
      that.getShopList();
    })
  },
  methods: {
    getShopList() {
      const that = this
      postApi(
          this.apiBase + "/api/fwm/getshoplist",
          {
            member_id: that.member_id,
          },
          function (data) {
            //{"code":0,"msg":"success","data":{"shoplist":[{"a_id":514,"code":"KTYHMJ0000011","is_company":0,"auth_company":"","auth_shopname":"测试是否自动缩小字号北京满客多科技发展有限公司了","content":"276485959","shopweb":"https:\/\/weidian.com\/?userid=1201566472&wfr=wx&sfr=app&source=home_shop&from=groupmessage"},{"a_id":513,"code":"KTYHMJ0000010","is_company":0,"auth_company":"","auth_shopname":"请问1+1在什么情况下等于0","content":"","shopweb":"https:\/\/shop59423886.taobao.com\/"},{"a_id":512,"code":"KTYHMJ0000009","is_company":0,"auth_company":"","auth_shopname":"幼儿园里最好吃的牛肉丸子","content":"yuan393447959","shopweb":""},{"a_id":511,"code":"KTYHMJ0000008","is_company":0,"auth_company":"","auth_shopname":"辣妈HK代购","content":"jinhuan630","shopweb":"http:\/\/lamahk.taobao.com\/"},{"a_id":510,"code":"KTYHMJ0000006","is_company":1,"auth_company":"上海凌澄贸易有限公司","auth_shopname":"","content":"","shopweb":""},{"a_id":509,"code":"KTYHMJ0000005","is_company":1,"auth_company":"杭州星诚贸易有限公司","auth_shopname":"","content":"","shopweb":""}]}}
            if (data.code === 0) {
              that.shops = data.data.shoplist;
              console.log(that.shops)
              let productList = that.products;
              if (productList && productList.length > 0) {
                for (let i = 0; i < productList.length; i++) {
                  const allShops = JSON.parse(
                      JSON.stringify(that.shops)
                  );
                  const pshops = [];
                  allShops.forEach(shop => {
                    if (shop.product_list && shop.product_list.includes(productList[i].product_id)) {
                      pshops.push(shop)
                    }
                  })
                  productList[i].shops = pshops;
                  Vue.set(that.products, i, productList[i]);
                }
              }
            } else {
              showToast(data.msg);
            }
          }
      );
    },
    activeThisShop(pindex, sindex) {
      let product = this.products[pindex];
      for (let i = 0; i < product.shops.length; i++) {
        if (i === sindex) {
          product.shops[i].active = !product.shops[i].active;
          if ( product.shops[i].active) {
            this.activeCount++
          } else {
            this.activeCount--
          }
          console.log(this.activeCount)
        }
      }
      Vue.set(this.products, pindex, product);
    },
    doActivate() {
      if(this.activeCount < 1) return
      const that = this;
      console.log("提交授权：", this.products);
      let pids = [];
      let aids = [];
      for (let i = 0; i < this.products.length; i++) {
        let p = this.products[i];
        pids.push(p.product_id);
        console.log("当前商品：", p);
        for (let j = 0; j < p.shops.length; j++) {
          let s = p.shops[j];
          console.log("当前店铺：", s);
          if (s.active) {
            aids.push(s.a_id);
          }
        }
      }
      postApi(
          this.apiBase + "/api/fwm/activationcode",
          {
            box_code: that.box_code,
            member_id: that.member_id,
            product_id: pids.join(","),
            a_id: aids.length > 0 ? aids.join(',') : 0,
          },
          function (data) {
            if (data.code === 0) {
              showToast('激活成功');
              //询问框
              // eslint-disable-next-line no-undef
              layer.open({
                content: '是否退出当前登录账户？'
                , btn: ['取消', '退出']
                , no: function (index) {
                  console.log('点击了退出按钮', index)
                  localStorage.removeItem('box_code_member_info')
                  localStorage.removeItem('box_code_member_expireat')
                  // eslint-disable-next-line no-undef
                  that.$router.push({
                    path: "/list",
                    query: {
                      box_code: that.box_code,
                    },
                  });
                },
                yes: function (index) {
                  console.log('点击了取消按钮', index)
                  //eslint-disable-next-line no-undef
                  layer.close(index);
                  that.$router.push({
                    path: "/list",
                    query: {
                      box_code: that.box_code,
                    },
                  });
                }
              });
            } else {
              showToast(data.msg);
            }
          }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.body {
  padding-bottom: 80px;

  .product {
    .block {
      height: 130px;
      padding: 0 20px;
      margin: 0 auto;
      background: #ffffff;
      display: flex;
      align-items: center;

      .image {
        width: 100px;
        height: 100px;
      }

      .info {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-left: 20px;

        .title {
          font-size: 20px;
          font-weight: bold;
        }

        .desc {
          font-size: 16px;
          margin-top: 5px;
        }

        .spec {
          display: flex;
          justify-content: flex-end;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 3px;
            background: #f0f2fb;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            font-size: 11.5px;
            color: #15093a;
            font-weight: bold;
          }

          .case {
          }

          .box {
            margin-left: 10px;
          }
        }
      }
    }

    .store.active {
      border: 1px solid #64a6eb;
      color: #1e6dbe !important;
      position: relative;

      .name {
        color: #1e6dbe;
      }

      .checked {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .store {
      display: flex;
      flex-direction: column;
      margin: 12px;
      border-radius: 5px;
      border: 1px solid #666666;
      padding: 10px;
      background: #ffffff;

      .cert-id {
        font-size: 10px;
        font-weight: bold;
      }

      .name {
        text-align: center;
        font-size: 17px;
        color: #555555;
        font-weight: bold;
        margin-top: 10px;
      }

      .url {
        text-align: center;
        font-size: 11px;
        margin-top: 10px;
        overflow-wrap: break-word;
      }

      .unchecked {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }

  .active-btn {
    height: 65px;
    width: 100%;
    background: #ff5554;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
    position: fixed;
    bottom: 0;
    border: none;
  }

  .inactive-btn {
    height: 65px;
    width: 100%;
    background: #999;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
    position: fixed;
    bottom: 0;
    border: none;
  }
}

.fixed {
  position: absolute;
  bottom: 0;
}
</style>
